import { defineStore } from 'pinia';
import { useUtilsStore } from "@/store";
import { useAuthStore } from "@/store";
import { useForgotPassStore } from "@/store";

export const useAccountStore = defineStore({
    id: 'account',
    state: () => ({
        accountName: useAuthStore().username
    }),
    
    actions: {
        async AccountSecureGetListByServiceID(serviceID, accountName = "") {
            try {
              let requestData = {
                RequestID: "",
                DeviceDetail: useUtilsStore().getDeviceDetail(),
                ClientIP: await useUtilsStore().getIPAddress(),
                AccessToken: "",
                AccountName: accountName == "" ? this.accountName : accountName,
                ServiceID: serviceID
              };
              
              const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AccountSecure_GetListByServiceID`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                }
              ).then((res) => {
                return res.json();
              });
              
              return response;
            } catch (ex) {
              console.log("ex: " + ex);
            }
        },
        async SendSecureCode(secureTypeID, serviceID) {
            try {
              let requestData = {
                RequestID: "",
                DeviceDetail: useUtilsStore().getDeviceDetail(),
                ClientIP: await useUtilsStore().getIPAddress(),
                AccessToken: "",
                AccountName: this.accountName || "",
                SecureTypeID: secureTypeID,
                ServiceID: serviceID
              };
              
              const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/SendSecureCode`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                }
              ).then((res) => {
                return res.json();
              });
              
              return response;
            } catch (ex) {
              console.log("ex: " + ex);
            }
        },
        async GetAccountInfo() {
          try {
            if(!useAuthStore().isAuthenticate){
              return;
            }
            let requestData = {
              RequestID: "",
              DeviceDetail: useAuthStore().userInfoMyVTC.DeviceDetail,
              ClientIP: useAuthStore().userInfoMyVTC.ClientIP,
              AccessToken: useAuthStore().userInfoMyVTC.AccessToken,
              AccountName: useAuthStore().userInfoMyVTC.AccountName,
            };
            
            const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_URL}v1.0/GetFullInfoAccount`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            }).then((res) => {
              return res.json();
            });
            
            return response;
          } catch (ex) {
            console.log("ex: " + ex);
          }
        },
        async GetAccountInfoToShare() {
          try {
            if(!useAuthStore().isAuthenticate){
              return;
            }
            let requestData = {
              RequestID: "",
              DeviceDetail: useAuthStore().userInfoMyVTC.DeviceDetail,
              ClientIP: useAuthStore().userInfoMyVTC.ClientIP,
              AccessToken: useAuthStore().userInfoMyVTC.AccessToken,
              AccountName: useAuthStore().userInfoMyVTC.AccountName,
              ServiceID: useAuthStore().serviceId
            };
            
            const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/GetAccountInfoToShare`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            }).then((res) => {
              return res.json();
            });
            
            return response;
          } catch (ex) {
            console.log("ex: " + ex);
          }
        },
    }
});